var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWalletConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93376 7.86428C8.83439 4.04524 15.1586 4.04524 19.0592 7.86428L19.5286 8.32391C19.7237 8.51486 19.7237 8.82445 19.5286 9.0154L17.9227 10.5877C17.8252 10.6832 17.6671 10.6832 17.5696 10.5877L16.9236 9.9552C14.2024 7.29094 9.79053 7.29094 7.06935 9.9552L6.37752 10.6326C6.28001 10.728 6.1219 10.728 6.02439 10.6326L4.4185 9.06026C4.22347 8.86931 4.22347 8.55971 4.4185 8.36876L4.93376 7.86428ZM22.3803 11.1159L23.8095 12.5153C24.0046 12.7062 24.0046 13.0158 23.8095 13.2068L17.365 19.5166C17.17 19.7076 16.8538 19.7076 16.6587 19.5166C16.6587 19.5166 16.6587 19.5166 16.6587 19.5166L12.0848 15.0384C12.036 14.9906 11.957 14.9906 11.9082 15.0384C11.9082 15.0384 11.9082 15.0384 11.9082 15.0384L7.33438 19.5166C7.13935 19.7076 6.82314 19.7076 6.6281 19.5166C6.6281 19.5166 6.6281 19.5166 6.6281 19.5166L0.183383 13.2067C-0.0116484 13.0158 -0.0116484 12.7062 0.183383 12.5152L1.61262 11.1159C1.80766 10.9249 2.12386 10.9249 2.3189 11.1159L6.8929 15.5942C6.94166 15.6419 7.02071 15.6419 7.06947 15.5942C7.06947 15.5942 7.06947 15.5942 7.06947 15.5942L11.6433 11.1159C11.8383 10.9249 12.1545 10.9249 12.3495 11.1159C12.3495 11.1159 12.3495 11.1159 12.3495 11.1159L16.9235 15.5942C16.9723 15.6419 17.0513 15.6419 17.1001 15.5942L21.674 11.1159C21.8691 10.925 22.1853 10.925 22.3803 11.1159Z",
    fill: "#3B99FC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletConnect);
export default __webpack_public_path__ + "static/media/wallet-connect.c1b43ae687621af75a6573d11606a6c5.svg";
export { ForwardRef as ReactComponent };